var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"KV_container",attrs:{"fluid":"","fill-height":""}},[_c('v-row',[_c('v-col',{staticClass:"KV_text"},[_c('p',{staticClass:"white--text"},[_vm._v("これで分かる！"),_c('br'),_vm._v("フロントエンドエンジニア 田中亜衣の全て")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }